// extracted by mini-css-extract-plugin
export default {"pageTitle":"style_pageTitle__hLqQt","content":"style_content__gV5Yq","contentContainer":"style_contentContainer__93+bf"};